/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Openquestionsaria2Inputs */

const en_openquestionsaria2 = /** @type {(inputs: Openquestionsaria2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open questions about your case file`)
};

const pt_openquestionsaria2 = /** @type {(inputs: Openquestionsaria2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pontos a esclarecer sobre o seu processo`)
};

/**
* | output |
* | --- |
* | "Open questions about your case file" |
*
* @param {Openquestionsaria2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const openquestionsaria2 = /** @type {((inputs?: Openquestionsaria2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Openquestionsaria2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_openquestionsaria2(inputs)
	return pt_openquestionsaria2(inputs)
});
export { openquestionsaria2 as "openQuestionsAria" }